export const HOME = { emergentLink: "home-emergent-link" };

export const TID = {
  // Header
  langToggle: "lang-toggle",
  userMenu: "user-menu",
  loginLink: "login-link",
  logoutBtn: "logout-btn",
  adminLink: "admin-link",

  // Home
  urlInput: "url-input",
  analyzeBtn: "analyze-btn",
  reportSection: "report-section",
  scoreOverall: "score-overall",
  scoreSeo: "score-seo",
  scoreSpeed: "score-speed",
  scoreAnalytics: "score-analytics",
  suggestionsList: "suggestions-list",

  // Targeting
  targetingForm: "targeting-form",
  genderAll: "gender-all",
  genderMale: "gender-male",
  genderFemale: "gender-female",
  ageSlider: "age-slider",
  interestsInput: "interests-input",
  interestsList: "interests-list",
  geoInput: "geo-input",
  durationSelect: "duration-select",
  dailyBudgetInput: "daily-budget-input",
  instagramInput: "instagram-input",
  waNumberInput: "wa-number-input",
  waMessageInput: "wa-message-input",
  waOpenChat: "wa-open-chat",
  launchBtn: "launch-campaign-btn",

  // Campaign dashboard
  campaignDash: "campaign-dashboard",
  liveLeads: "live-leads-feed",
  warmupBanner: "warmup-banner",
  newCampaignBtn: "new-campaign-btn",

  // Auth
  emailInput: "email-input",
  passwordInput: "password-input",
  nameInput: "name-input",
  submitLoginBtn: "submit-login-btn",
  submitRegisterBtn: "submit-register-btn",
  googleLoginBtn: "google-login-btn",
  goToRegister: "go-to-register",
  goToLogin: "go-to-login",

  // Admin
  adminStats: "admin-stats",
  adminUsers: "admin-users",
  adminOrders: "admin-orders",
  adminCampaigns: "admin-campaigns",
  adminApiKeys: "admin-api-keys",
  saveKeysBtn: "save-keys-btn",
  adminTabUsers: "admin-tab-users",
  adminTabOrders: "admin-tab-orders",
  adminTabCampaigns: "admin-tab-campaigns",
  adminTabComms: "admin-tab-comms",
  adminTabKeys: "admin-tab-keys",
  adminComms: "admin-comms",

  // Payment
  payNowBtn: "pay-now-btn",
};
